import type { ICookiesClient } from "@tiendeo/cookies";
import TiendeoStatsClient, { getPlatform } from "@tiendeo/js-stats-client";
import type { IConfig } from "config/IConfig";
import type { ProfilePages } from "enums/ProfilePageTypes";
import { TIENDEO } from "utils/constants";

const hasWindow = typeof window !== "undefined";

export function getStatsData(
    city: string,
    search: string,
    pageType: ProfilePages = "USER_PROFILE",
) {
    return {
        SearchCity: city,
        SearchWord: search,
        NumResults: 0,
        InitialUrl: "",
        PageType: pageType,
        Platform: hasWindow ? getPlatform(window.navigator.userAgent) : "",
        Origin: TIENDEO,
        SearchType: "PROFILE",
        Integration: TIENDEO,
    };
}

export const createStatsClient = (
    configs: IConfig,
    pageType: ProfilePages,
    cookiesClient: ICookiesClient,
    searchWord?: string,
) =>
    new TiendeoStatsClient(
        { URL_STATS_API: configs.url_stats_api },
        getStatsData("no_city", searchWord || "profile", pageType),
        cookiesClient.Get,
        cookiesClient.Set,
    );
